const layout = 'de/layout/*,en/layout/*,de-AT/layout/*';

export const excludingSlugs = [layout].join(',');
